import angular from 'angular';

CompanyContactsController.$inject = [
  'TopToolbarFactory',
  '$stateParams',
  '$scope',
  '$translate',
  'CompanyContactsFactory',
  'companyContacts',
  'AlertingFactory',
  'ConfirmationFactory',
  '$mdDialog',
  'MediasFactory',
];

export function CompanyContactsController(
  TopToolbarFactory,
  $stateParams,
  $scope,
  $translate,
  CompanyContactsFactory,
  companyContacts,
  AlertingFactory,
  ConfirmationFactory,
  $mdDialog,
  MediasFactory
) {

  $scope.deleteCompanyContact = deleteCompanyContact;
  $scope.createCompanyContact = createCompanyContact;
  $scope.editCompanyContact = editCompanyContact;
  $scope.exportXls = exportXls;
  $scope.filters = {};
  $scope.dropdownItems = {
    yesOrNo: [
      {
        id: 0,
        label: $translate.instant('no')
      },
      {
        id: 1,
        label: $translate.instant('yes')
      }
    ]
  }


  init();

  function deleteCompanyContact(companyContact, event) {
    ConfirmationFactory.materialConfirmDialog('parameters/company-contacts/confirm_contact_deletion')
      .then(() => {
        CompanyContactsFactory.deleteCompanyContact($stateParams.companyId, companyContact.id).then(
          () => {
            $scope.companyContacts = $scope.companyContacts.filter(c => c.id !== companyContact.id);
            $scope.filteredCompanyContacts = angular.copy($scope.companyContacts);
          },
          AlertingFactory.httpErrorHandler());
      });
  }

  function createCompanyContact(companyContact, event) {
    $mdDialog.show({
      'controller': 'CompanyContactEditOrCreateController',
      'template': require('./company-contact-edit-or-create.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        'companyContact': companyContact
      }
    })
      .then(companyContact => {
        CompanyContactsFactory.createCompanyContact($stateParams.companyId, companyContact)
          .then((res) => {
            companyContact.id = res.data[0].id;
            companyContact.name = res.data[0].name;
            companyContact.email = res.data[0].email;
            companyContact.phone = res.data[0].phone;
            companyContact.alerts = res.data[0].alerts;
            companyContact.newsAlcmeon = res.data[0].newsAlcmeon;
            companyContact.gdprReferent = res.data[0].gdprReferent;
            $scope.companyContacts.push(companyContact);
            $scope.filteredCompanyContacts = angular.copy($scope.companyContacts);
          },
            AlertingFactory.httpErrorHandler());
      });
  }

  function editCompanyContact(companyContact, event) {
    $mdDialog.show({
      'controller': 'CompanyContactEditOrCreateController',
      'template': require('./company-contact-edit-or-create.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        'companyContact': companyContact
      }
    })
      .then(companyContact => {
        CompanyContactsFactory.editCompanyContact($stateParams.companyId, companyContact)
          .then((response) => {
            if (response.data.error && response.data.error.reason) {
              AlertingFactory.error(response.data.error.reason);
            }
          }
          );
      });
  }

  function filterCompanyContacts() {
    $scope.filteredCompanyContacts = $scope.companyContacts.filter(companyContact => {
      for (var key in $scope.filters) {
        // Dropdown selectors
        if ($scope.filters[key].length > 0) {
          if (!$scope.filters[key].some(id => companyContact[key] === id)) {
            return false;
          }
        }
      }
      return true;
    });
  }

  function exportXls() {
    CompanyContactsFactory.createExport($stateParams.companyId, $scope.filteredCompanyContacts).then(response => {
      const { content, content_type, content_filename } = response.data;
      MediasFactory.downloadBinaryBase64(content, content_type, content_filename);
    }, AlertingFactory.httpErrorHandler());
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('parameters/company-contacts/toolbar-title', $scope);
    TopToolbarFactory.setButton('parameters/company-contacts/create_new_contact', createCompanyContact, $scope);
    TopToolbarFactory.setTooltip($translate.instant('parameters/company-contacts/tooltip'), $scope);
    $scope.companyContacts = companyContacts;
    $scope.filteredCompanyContacts = angular.copy($scope.companyContacts);
    $scope.sortContacts = 'name';
    // Headers
    $scope.headers = {
      name: $translate.instant('common/name'),
      email: $translate.instant('email'),
      phone: $translate.instant('phone'),
      alerts: $translate.instant('parameters/company-contacts/alerts'),
      newsAlcmeon: $translate.instant('parameters/company-contacts/news-alcmeon'),
      gdprReferent: $translate.instant('parameters/company-contacts/gdpr-referent')
    };

    $scope.alertsKey = 'contacts/alerts';
    $scope.alertsLabel = $translate.instant('parameters/company-contacts/alerts');
    $scope.newsAlcmeonKey = 'contacts/newsAlcmeon'
    $scope.newsAlcmeonLabel = $translate.instant('parameters/company-contacts/news-alcmeon') + ' | ' + $translate.instant('common/name');
    $scope.gdprReferentKey = 'contacts/gdprReferent'
    $scope.gdprReferentLabel = $translate.instant('parameters/company-contacts/gdpr-referent') + ' | ' + $translate.instant('common/name');
  }

  // Filter company on filter change
  $scope.$watch('filters', (newValue, oldValue) => {
    if (newValue !== oldValue) {
      filterCompanyContacts();
    }
  }, true);

}
